/**
 * Phone chrome for the player-count editor (W5). The body is shared with the
 * desktop modal — see `components/PlayerCountEditor.tsx`.
 *
 * `phone` widens the inputs to 48px and stacks RESET under the CTA rather than
 * beside it, which is what the phone mirror does and what a thumb needs.
 */

import { PlayerCountEditor } from '../components/PlayerCountEditor.tsx';
import { Sheet } from '../components/Sheet.tsx';
import { useQd } from '../store/index.ts';

export default function PlayerCountSheet(): JSX.Element | null {
  const s = useQd();
  const g = s.gById(s.capOpen);
  if (!s.capOpen || !g) return null;
  return (
    <Sheet
      label="Player count"
      onClose={() => s.closeCap()}
      header={{ title: 'PLAYER COUNT', note: g.n.toUpperCase() }}
    >
      <PlayerCountEditor phone />
    </Sheet>
  );
}
